export const LOCAL_STORAGE = {
    SALE_KEY: 'SALE_KEY',
    ROOT_KEY: 'root',
    SECRET_KEY: 'BYME-23'
};
